export const isSvgDataUri = (url?: string): url is string => {
  return !!url && url.startsWith("data:image/svg+xml");
};

export const isSvgBase64DataUri = (url?: string): url is string => {
  return !!url && url.startsWith("data:image/svg+xml;base64,");
};
